import React from 'react';
import { Controller, FieldValues, useFormContext } from 'react-hook-form';

import { FormErrorMessage } from '@/shared/components/ui/form/components/form-error-message/form-error-message';
import { Radio } from '@/shared/components/ui/form/components/radio/radio';
import { RadioGroupOption } from '@/shared/components/ui/form/components/radio-group/radio-group.styled';
import { RadioToggleFormControl } from '@/shared/components/ui/form/components/radio-toggle/radio-toggle.styled';
import { TRadioToggleProps } from '@/shared/components/ui/form/components/radio-toggle/radio-toggle.types';
import { TruncatedText } from '@/shared/components/ui/truncated-text/truncated-text';

export const RadioToggle = <TFieldValues extends FieldValues>({
  name,
  label,
  disabled,
  defaultValue,
}: TRadioToggleProps<TFieldValues>) => {
  const { control } = useFormContext<TFieldValues>();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { onChange, value, ...fieldProps }, fieldState }) => {
        return (
          <RadioToggleFormControl>
            <RadioGroupOption
              {...fieldProps}
              onClick={() => onChange(!value)}
              value={value}
              checked={!!value}
              $error={Boolean(fieldState?.error)}
              control={<Radio disabled={disabled} />}
              label={
                <TruncatedText
                  onClick={(event) => {
                    event.stopPropagation();
                  }}
                  variant="p8"
                  maxLength={14}
                  text={label}
                />
              }
            />
            {fieldState?.error && <FormErrorMessage field={label} />}
          </RadioToggleFormControl>
        );
      }}
    />
  );
};
